import {NgxTranslation, NgxTranslationExtras} from '@ngx-translations/translations.interfaces';
import {NgxTranslations} from '@ngx-translations/translations.service';
import {Optional, Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'ngxTranslate'
})
export class NgxTranslationsPipe implements PipeTransform {

    constructor(@Optional() private _translate: NgxTranslations) {
    }

    transform(value: string | NgxTranslation, args: NgxTranslationExtras = {}) {
        // Check if the service was actually properly installed; if not return the value.
        if (!this._translate) {
            return value;
        }

        // If the value was not received properly return null.
        if (!value) {
            return null;
        }

        // Check if the arguments were formatted properly.
        if (typeof args !== 'object') {
            throw new Error('The arguments were not formatted properly.');
        }

        if (typeof value === 'string') {
            value = {token: value, data: args};
        }

        // Translate the value.
        return this._translate.instant(value);
    }

}

@Pipe({
    name: 'ngxDate'
})
export class NgxDatePipe implements PipeTransform {

    constructor(@Optional() private _translate: NgxTranslations) {
    }

    transform(value: any, format?: string, timezone?: string): any {
        const locale = this._translate.getLocale();
        const pipe = new DatePipe(locale || 'en-US');

        return pipe.transform(value, format);
    }

}
